__turbopack_context__.v({
  "breadcrumbsWrapper": "FolderHeader-module___mnY1G__breadcrumbsWrapper",
  "folderHeader": "FolderHeader-module___mnY1G__folderHeader",
  "folderHeaderInfo": "FolderHeader-module___mnY1G__folderHeaderInfo",
});
